import { render, staticRenderFns } from "./Kunden.vue?vue&type=template&id=796e3486&"
import script from "./Kunden.vue?vue&type=script&lang=js&"
export * from "./Kunden.vue?vue&type=script&lang=js&"
import style0 from "./Kunden.vue?vue&type=style&index=0&id=796e3486&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports